import type { BlogCategory } from '@bulknutrients/bulk-shared-lib/interfaces/Blog';
import { getBlogCategoryNames } from '@bulknutrients/bulk-shared-lib/lib/sanity/blogData';
import { BlogCardList } from '@components/Blog/BlogCardList';
import { BlogCategoryNavBar } from '@components/Blog/BlogCategoryNavBar';
import { BlogIntro } from '@components/Blog/BlogIntro';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { Container } from '@components/Container';
import { StandardLayout } from '@components/Layouts';
import type { GetStaticProps } from 'next';
import Head from 'next/head';
import type { ReactElement } from 'react';

export default function BlogLandingPage({
  blogCategories,
  breadcrumbs,
}: {
  blogCategories: BlogCategory[];
  breadcrumbs: { title: string; path: string }[];
}): ReactElement {
  return (
    <>
      <Head>
        <title>Bulk Nutrients' Blog has high quality supplement articles</title>
        <meta
          name="title"
          content="Bulk Nutrients' Blog has high quality supplement articles"
        />
        <meta
          name="description"
          content="Bulk Nutrients' blog is full of high quality supplement articles, latest research, workouts, recipes and feature articles for extended product information"
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SERVER_URL}/blog`}
        />
      </Head>
      <Container>
        <Breadcrumbs crumbs={breadcrumbs} />
      </Container>
      <Container as="main" id="main-content" className="mb-12.5">
        <BlogIntro />
        <BlogCategoryNavBar blogCategories={blogCategories} />
        <BlogCardList />
      </Container>
    </>
  );
}

BlogLandingPage.getLayout = function getLayout(page: ReactElement) {
  return <StandardLayout>{page}</StandardLayout>;
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const blogCategories = await getBlogCategoryNames();

  const breadcrumbs = [
    { title: 'home', path: '/' },
    { title: 'The Bulk Nutrients Blog', path: '/blog/' },
  ];

  return {
    props: {
      blogCategories,
      breadcrumbs,
    },
  };
};
